// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"dfca81f9","213":"1b7619a5","455":"5731c6bc"}[chunkId] + ".chunk.js";
};